module.exports = __webpack_public_path__ + "static/media/caros-black.97cc3b9f.woff2";